class TC_ConfigurableHeader {
    constructor () {
        this.videoData = {};
        this.popupRendered = false;
        this.header = null;
        this.defaultVideoId = null;
        this.defaultColor = null;
        this.defaultOpacity = null;
        this.popup = null;
        this.button = null;
        this.closeButton = null;
        this.resetButton = null;
        this.overlay = null;
        this.state = {
            video: null,
            color: null,
            opacity: null
        };

        if ($('.heading-configure-button').length) {
            this.initEvents();
        }
    }

    initEvents () {
        let url = 'https://api.' + window.CSITE.appDomain + '/v1/videos/background-videos-christian-05-2020.json';
        this.header = $('.heading-frontpage');
        this.button = $('.heading-configure-button');
        this.overlay = $('.heading-overlay');
        this.defaultVideoId = this.header.attr('data-video-id');
        this.defaultColor = this.header.attr('data-overlay-color');
        this.defaultOpacity = this.header.attr('data-overlay-opacity');

        this.state = {
            video: parseInt(window.localStorage.getItem('calmchristian-frontpage-video') || this.defaultVideoId, 10),
            color: (Cookies.get('calmradio-header') ? Cookies.get('calmradio-header').split(',')[0] : false) || this.defaultColor,
            opacity: (Cookies.get('calmradio-header') ? Cookies.get('calmradio-header').split(',')[1] : false) || this.defaultOpacity
        };

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.videoData = JSON.parse(JSON.stringify(data));
                this.button.addClass('is-active');
                this.showVideo();
            }
        });

        $('.heading-configure-button').on('click', (e) => {
            e.preventDefault();
            this.showPopup();
        });
    }

    showVideo (selectedID = false) {
        if (!selectedID) {
            selectedID = this.state.video;
        }

        let selectedVideo = this.videoData.videos.filter(item => item.id === selectedID);

        if (!selectedVideo.length && this.videoData.videos.length) {
            selectedVideo = this.videoData.videos.filter(item => item.position === 0);
        }

        if (selectedVideo.length) {
            if (this.header.find('.video-cover').length) {
                this.overlay.css('opacity', 1);
                this.header.find('.video-cover').remove();
            }

            let video = $('<div class="video-cover"><video loop muted autoplay></video></div>');
            video.find('video').attr('src', selectedVideo[0].hd_desktop_video);
            video.appendTo(this.header);

            video.find('video').on('loadeddata', () => {
                this.overlay.css('opacity', this.overlay.attr('data-opacity') / 100.0);
            });
        }
    }

    showPopup () {
        if (!this.popupRendered) {
            this.renderPopup();
        }

        this.popup.css('display', 'block');

        setTimeout(() => {
            this.popup.addClass('is-active');
        }, 0);
    }

    hidePopup () {
        this.popup.removeClass('is-active');

        setTimeout(() => {
            this.popup.css('display', 'none');
        }, 300);
    }

    renderPopup () {
        let videosList = this.renderVideosList();
        let output = `
            <div class="heading-popup">
                <h2 class="heading-popup-title">
                    ${window.CSITE_LANGS.headerPopup.title}
                    <a href="#" class="heading-popup-reset">
                        ${window.CSITE_LANGS.headerPopup.reset}
                    </a>
                </h2>
                <a href="#close" class="heading-popup-close"></a>
                <div class="heading-popup-option">
                    <label>${window.CSITE_LANGS.headerPopup.overlayColor}</label>
                    <div class="colorpicker-preview"></div>
                    <input type="colorpicker" class="heading-popup-option-color" />
                </div>
                <div class="heading-popup-option">
                    <label>${window.CSITE_LANGS.headerPopup.overlayOpacity}</label>
                    <input type="range" class="heading-popup-option-opacity" />
                </div>

                <div class="heading-popup-videos">
                    ${videosList}
                </div>
            </div>
        `;

        this.popup = $(DOMPurify.sanitize(output));
        this.popup.appendTo(this.header);
        this.popup.find('img').each((i, img) => {
            img = $(img);
            img.on('load', () => img.removeClass('is-inactive').addClass('is-active'));
        });

        this.debouncedSave = debounce(this.saveCookie.bind(this), 1000);

        let colorPicker = this.popup.find('.heading-popup-option-color');
        colorPicker.val(this.state.color);
        colorPicker.on('change', () => {
            this.overlay.css('background-color', colorPicker.val());
            this.state.color = colorPicker.val();
            this.debouncedSave();
        });

        let opacityPicker = this.popup.find('.heading-popup-option-opacity');
        opacityPicker.val(this.state.opacity);
        opacityPicker.on('change', () => {
            this.overlay.css('opacity', opacityPicker.val() / 100.0);
            this.state.opacity = opacityPicker.val();
            this.overlay.attr('data-opacity', opacityPicker.val());
            this.debouncedSave();
        });

        this.closeButton = this.popup.find('.heading-popup-close');
        this.closeButton.on('click', e => {
            e.preventDefault();
            this.hidePopup();
        });

        this.resetButton = this.popup.find('.heading-popup-reset');
        this.resetButton.on('click', e => {
            e.preventDefault();

            this.state = {
                video: this.defaultVideoId,
                color: this.defaultColor,
                opacity: this.defaultOpacity
            };

            try {
                window.localStorage.setItem('calmchristian-frontpage-video', this.defaultVideoId);
            } catch (e) {
                console.log('LocalStorage is not available under private mode.');
            }

            Cookies.set('calmradio-header', this.defaultColor + ',' + this.defaultOpacity, { expires: 90 });
            this.overlay.css('background-color', this.defaultColor);
            this.overlay.css('opacity', this.defaultOpacity / 100.0);
            this.overlay.attr('data-opacity', this.defaultOpacity);
            opacityPicker.val(this.state.opacity);
            $(opacityPicker).rangeslider('update', true);
            colorPicker.val(this.state.color);
            $('.colorpicker-preview').css('background-color', this.state.color);
            this.showVideo(this.defaultVideoId);
            this.hidePopup();
        });

        $('.heading-popup-videos-item').each((i, item) => {
            item = $(item);
            item.on('click', () => {
                let videoID = parseInt(item.attr('data-id'), 10);
                this.showVideo(videoID);
                this.hidePopup();

                try {
                    window.localStorage.setItem('calmchristian-frontpage-video', videoID);
                } catch (e) {
                    console.log('LocalStorage is not available under private mode.');
                }
            });
        });

        this.initColorPicker();
        this.initRangeSliders();
        this.popupRendered = true;
    }

    initColorPicker() {
        let colorpicker = $('input[type="colorpicker"]');
        $(colorpicker).attr('readonly', true);
        $(colorpicker).colorPicker({
            customBG: '#222',
            margin: '4px -2px 0 0',
            doRender: 'div div',

            buildCallback: function ($elm) {
                var colorInstance = this.color,
                    colorPicker = this;

                $elm.prepend('<div class="cp-panel"><div class="cp-panel-hidden">' +
                    'R <input type="text" class="cp-r" /><br>' +
                    'G <input type="text" class="cp-g" /><br>' +
                    'B <input type="text" class="cp-b" /><hr>' +
                    'H <input type="text" class="cp-h" /><br>' +
                    'S <input type="text" class="cp-s" /><br>' +
                    'B <input type="text" class="cp-v" /></div>' +
                    '<input type="text" maxlength="6" class="cp-HEX" />' +
                    '</div>').on('change', 'input', function (e) {
                    var value = this.value,
                        className = this.className,
                        type = className.split('-')[1],
                        color = {};

                    color[type] = value;
                    colorInstance.setColor(type === 'HEX' ? value : color,
                        type === 'HEX' ? 'HEX' : /(?:r|g|b)/.test(type) ? 'rgb' : 'hsv');
                    colorPicker.render();
                    this.blur();
                });
            },

            renderCallback: function ($elm, toggled) {
                if (!this.$trigger) {
                    return;
                }

                var colors = this.color.colors.RND,
                    modes = {
                        r: colors.rgb.r, g: colors.rgb.g, b: colors.rgb.b,
                        h: colors.hsv.h, s: colors.hsv.s, v: colors.hsv.v,
                        HEX: this.color.colors.HEX
                    };

                $('input', '.cp-panel').each(function () {
                    this.value = modes[this.className.substr(3)];
                });
            },

            positionCallback: function ($elm) {
                var $UI = this.$UI, // this is the instance; this.$UI is the colorPicker DOMElement
                    position = $elm.position(); // $elm is the current trigger that opened the UI

                // $UI.appendTo('#somwhereElse');
                // do here your calculations with top and left and then...
                return { // the object will be used as in $('.something').css({...});
                    left: position.left + 52,
                    top: position.top + $elm.outerHeight() + $(document.body).scrollTop() + 20
                };
            }
        });
    }

    initRangeSliders () {
        this.popup.find('input[type="range"]').rangeslider({
            polyfill: false
        });
    }

    renderVideosList () {
        let output = ``;
        let filteredVideos = this.videoData.videos.filter(video => video.category_id !== 16);
        filteredVideos.sort((videoA, videoB) => videoA.position - videoB.position);

        for (let i = 0; i < filteredVideos.length; i++) {
            output += `
            <figure class="heading-popup-videos-item" data-id="${filteredVideos[i].id}">
                <img src="${filteredVideos[i].hd_mobile_thumbnail}" class="is-inactive" />
                <span class="heading-popup-videos-placeholder"></span>
                <figcaption>
                    ${filteredVideos[i].name}
                </figcaption>
            </figure>
            `;
        }

        return output;
    }

    saveCookie () {
        Cookies.set('calmradio-header', [this.state.color, this.state.opacity].join(','), { expires: 90 });
    }
}

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};